/*
 * !!!Warning!!!
 * This component has been copied from ../../../../main/src/components/SocialSharing
 * If any changes are to be made in this file, it should also be made in the original
 */

import React from "react";
import SocialSharingList from "../SocialSharingList/SocialSharingList";

let idCounter = 0;

class SocialSharing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      linkCssClasses: "",
      menuCssClasses: "social-sharing-list level-2",
      hideSharingText: this.props.hideSharingText || false,
      labelId: `social-sharing-label-${++idCounter}`,
      controlsId: `social-sharing-controls-${++idCounter}`,
      shareButtonText: "Del",
    };

    if (this.props.additionalLinkCssClasses)
      this.state.linkCssClasses += ` ${this.props.additionalLinkCssClasses}`;

    if (this.props.additionalMenuCssClasses)
      this.state.menuCssClasses += ` ${this.props.additionalMenuCssClasses}`;
  }

  sharingButtonClick(e) {
    window.stortinget.initializeSocialButton(e);
  }

  render() {
    let url = encodeURIComponent(this.props.url || "https://www.stortinget.no");
    return (
      <div className="social-sharing-container">
        <button
          href="#social-sharing"
          id={this.state.labelId}
          type="button"
          className={this.state.linkCssClasses}
          aria-controls={this.state.controlsId}
          aria-expanded="false"
          onClick={this.sharingButtonClick}
        >
          {this.state.hideSharingText ? (
            <span className="visuallyhidden">{this.state.shareButtonText}</span>
          ) : (
            this.state.shareButtonText
          )}
        </button>
        <ul
          id={this.state.controlsId}
          className={this.state.menuCssClasses}
          aria-labelledby={this.state.labelId}
          data-social-selector
        >
          <SocialSharingList
            url={"https://www.facebook.com/sharer.php?u=" + url}
            name="facebook"
          />
          <SocialSharingList
            url={"https://twitter.com/share?url=" + url}
            name="twitter"
          />
          <SocialSharingList
            url={"mailto:?subject=Tips%20fra%20stortinget.no&body=" + url}
            name="email"
          />
        </ul>
      </div>
    );
  }
}

export default SocialSharing;
